<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CompleteInvoicesAlt"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpAlert
      variant="info"
      show
    >
      <p
        class="mb-0"
      >
        <ItpIcon
          fa="info-circle"
        >
        </ItpIcon>
        <ItpText
          wrap
        >
          Kiállítás után a számla már nem módosítható.
        </ItpText>
      </p>
    </ItpAlert>
    <ItpForm
      :id="formId"
      name="confirmSyncInvoice"
      ref="mainForm"
      @submit="evh_4186377094414664_submit($event, {})"
    >
      <ItpFormGroup
        name="create_register_entry"
        :label="'Filing'|pgettext('InvoiceSync')"
        :helpTooltip="'Create a register entry after issuing the invoice.'|pgettext('InvoiceSync')"
        :labelAlign="labelAlign"
        labelColsMd="4"
        contentColsMd="8"
      >
        <div
          class="input-group-prepend"
        >
          <div>
            <ItpFormCheckbox
              name="print"
              v-model="payload.create_register_entry"
              required
            >
            </ItpFormCheckbox>
          </div>
        </div>
      </ItpFormGroup>
      <ItpFormGroup
        name="register_entry_subject"
        :label="'Filing subject'|pgettext('InvoiceSync')"
        :helpTooltip="'Use the given subject for the register entries.'|pgettext('InvoiceSync')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="register_entry_subject_enabled"
              v-model="register_entry_subject_enabled"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          name="register_entry_subject"
          v-model="payload.register_entry_subject"
          :disabled="!register_entry_subject_enabled"
          class="w-auto"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="copies"
        :label="'Print'|pgettext('InvoiceSync')"
        :labelAlign="labelAlign"
        labelColsMd="4"
        contentColsMd="8"
        contentClass="input-group"
      >
        <ItpFormCheckbox
          name="print"
          v-model="payload.print"
          required
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="copies"
        :label="'Copies'|pgettext('InvoiceSync')"
        :labelAlign="labelAlign"
        labelColsMd="4"
        contentColsMd="2"
      >
        <div
          class="input-group"
        >
          <ItpFormInput
            type="number"
            name="print_copies"
            v-model="payload.print_copies"
            required
            :disabled="!payload.print"
          >
          </ItpFormInput>
        </div>
      </ItpFormGroup>
      <ItpFormGroup
        name="copies"
        :label="'Printer'|pgettext('InvoiceSync')"
        :labelAlign="labelAlign"
        labelColsMd="4"
        contentColsMd="8"
      >
        <UcPrinterSelector
          :item="payload"
          path="printer"
          clearable
          :disabled="!payload.print"
        >
        </UcPrinterSelector>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Complete invoices'|pgettext('CompleteInvoices|Submit')"
      :disabled="!forms.confirmSyncInvoice || !forms.confirmSyncInvoice.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CompleteInvoicesAlt extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_register_entry_subject_enabled = new ComponentValueCache(this, "register_entry_subject_enabled", "IssueInvoices.register_entry_subject_enabled");
    this.$$cache_payload = new ComponentValueCache(this, "payload", "IssueInvoices.payload_v2");
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  labelAlign!: any;
  register_entry_subject_enabled!: any;
  payload!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['labelAlign', 'register_entry_subject_enabled', 'payload', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        register_entry_subject_enabled: false,
        payload: {
          print: false,
          print_copies: 1,
          printer: null,
          target: "remote",
          create_register_entry: false,
          register_entry_subject: null,
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("CompleteInvoices|Title", "Complete Invoices"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_7256_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_7256, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_closeComponent_7258_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_2248226175642056_closeComponent_7258, alias=undefined
    return {
      result: {
        cancel: true,
      }
      ,
    }
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_4186377094414664_closeComponent_7260_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_4186377094414664_closeComponent_7260, alias=submit
    return {
      result: {
        close: true,
        ok: true,
        value: _.extend({}, this.payload, {
          register_entry_subject: this.payload.create_register_entry && this.register_entry_subject_enabled
            ? this.payload.register_entry_subject
            : null,
          printer: this.payload.print && this.payload.printer
            ? { id: this.payload.printer.id }
            : null
        }),
      }
      ,
    }
  }

  async evh_4186377094414664_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4186377094414664_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_7256: actions.CloseModalAction;
    evh_7315092382398562_close_7255: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_7258: actions.CloseComponentAction;
    evh_2248226175642056_close_7257: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_4186377094414664_closeComponent_7260: actions.CloseComponentAction;
    evh_4186377094414664_submit_7259: actions.EventHandlerImpl;
    evh_4186377094414664_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_7262: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_7261: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_7256 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_7256_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_7255 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_7256,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_7255],
      }
    );
    const act_2248226175642056_closeComponent_7258 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_2248226175642056_closeComponent_7258_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_close_7257 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_7258,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_7257],
      }
    );
    const act_4186377094414664_closeComponent_7260 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_4186377094414664_closeComponent_7260_getActionArgs,
        displayName: "submit",
        events: [],
      }
    );
    const evh_4186377094414664_submit_7259 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_closeComponent_7260,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_4186377094414664_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_4186377094414664_submit_7259],
      }
    );
    const act_1419464017721962_closeComponent_7262 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_7261 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_7262,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_7261],
      }
    );
    return {
      act_7315092382398562_closeModal_7256,
      evh_7315092382398562_close_7255,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_7258,
      evh_2248226175642056_close_7257,
      evh_2248226175642056_close,
      act_4186377094414664_closeComponent_7260,
      evh_4186377094414664_submit_7259,
      evh_4186377094414664_submit,
      act_1419464017721962_closeComponent_7262,
      evh_1419464017721962_clickPreventStop_7261,
      evh_1419464017721962_clickPreventStop,
      submit: act_4186377094414664_closeComponent_7260,
    }
  }
}

Vue.component("CompleteInvoicesAlt", CompleteInvoicesAlt);

</script>